import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AdaConfiguration } from '../../configuration/ada/ada-configuration';
import { Observable } from 'rxjs';
import { ListaAdaView } from '../../model/lista-ada-view';

@Injectable({
  providedIn: 'root'
})
export class AdaService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  })
  constructor(public http: HttpClient) { }

  ricercaAdaByIdProfilo(id:any): Observable<ListaAdaView[]> {
    return this.http.get<ListaAdaView[]>(AdaConfiguration.ricercaAdaByIdProfilo + id, { headers: this.headers });
  }

  ricercaAdaByIdCompetenza(id:any): Observable<ListaAdaView[]> {
    return this.http.get<ListaAdaView[]>(AdaConfiguration.ricercaAdaByIdCompetenza + id, { headers: this.headers });
  }

  ricercaAda(data: any, page: number, pageSize: number, searchType: number): Observable<ListaAdaView[]> {
    return this.http.post<ListaAdaView[]>(AdaConfiguration.ricercaAda + page + "/" + pageSize + "/" + searchType, data, { headers: this.headers });
  }

  salvaAdaByIdProfilo(data:any,id:any) {
    return this.http.post<any[]>(AdaConfiguration.salvaAdaByIdProfilo + id, data, { headers: this.headers });
  }

  salvaAdaByIdCompetenza(data:any,id:any) {
    return this.http.post<any[]>(AdaConfiguration.salvaAdaByIdCompetenza + id, data, { headers: this.headers });
  }

  getCodiciAdaByIdProposta(id:any): Observable<ListaAdaView[]> {
    return this.http.get<ListaAdaView[]>(AdaConfiguration.getCodiciAdaByIdProposta + id, { headers: this.headers });
  }

  getCodiciAdaByIdCompetenza(id:any): Observable<ListaAdaView[]> {
    return this.http.get<ListaAdaView[]>(AdaConfiguration.getCodiciAdaByIdCompetenza + id, { headers: this.headers });
  }

  getElencoAda(data: string): Observable<any[]> {
    return this.http.get<any[]>(AdaConfiguration.getElencoAda + data, { headers: this.headers });
  }

  
}



